import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import Icon from './Icon';

const StyledIconWrapper = styled.div`
        width: ${props => props.toolbar ? props.theme.space[8] : props.theme.space[9]};
        height: ${props => props.toolbar ? props.theme.space[8] : props.theme.space[9]};
        order: 2;
    `;

const ButtonWrapper = styled.div`
        
        & .stolo-raised-secondary {
            align-items: center;
            background-color: ${props => props.theme.palette.secondary.main};
            border: none;
            box-sizing: border-box;
            cursor: pointer;
            display: inline-flex;
            font-size: 1em;
            justify-content: center;
            padding: ${props => props.theme.space[5]} ${props => props.theme.space[8]};
            order: 2;
            outline: none;
            height: ${props => props.toolbar ? '1.85em' : '2.3em'};
            min-height: ${props => props.theme.space[11]};
            width: ${props => props.theme.space[12]};
            min-width: inherit;
            text-align: center;
            margin: 0;
            position: relative;
            index: 5;
            vertical-align: middle;
        }
        
        & button:hover{
          background-color: ${props => props.theme.palette.secondary.light};
        }
    `;

const SearchIcon = ({ handleClick, toolbar }) => (
    <ButtonWrapper>
        <Button
            classes={{ raisedSecondary: 'stolo-raised-secondary' }}
            variant='raised'
            color='secondary'
            onClick={handleClick}
        >
            <StyledIconWrapper toolbar={toolbar}>
                <Icon
                    name='icon-search'
                    iconColor='common.white'
                    width='1.3em'
                    height='1.3em'
                />
            </StyledIconWrapper>
        </Button>
    </ButtonWrapper>
);

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/components/SearchIcon.js